import * as React from 'react';
import { connect } from 'react-redux';

import '../Main.scss';

import { ApplicationState } from '../../Store';
import { BrandConfig, GetBrandConfig } from '../../Store/Tenant';

import { LinkMode } from '../../Store/ImportFinancials';
import { GetPortalText } from '../../Store/PortalAssets';

import { PortalTextCommon } from '../../Models/Api/strongbox.financialportal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faFileExport,
    faShareAlt,
    faQuestion,
} from '@awesome.me/kit-8a0d2fd588/icons/modules/sharp/light';

import {
    Tooltip
} from '@mui/material';

type InjectedReduxState = {
    brandConfig: BrandConfig;
    commonText?: PortalTextCommon;
};

type InjectedActionCreators = {};

type SubmittedByIconProps = {
    linkType?: LinkMode;
    iconStyle?: React.CSSProperties;
    iconId: string;
};

type Props = SubmittedByIconProps & InjectedActionCreators & InjectedReduxState;

const SubmittedByIconComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        iconId,
        iconStyle,
        linkType,
        commonText,
    } = props;

    const content = React.useMemo(() => {
        switch (linkType) {
            case LinkMode.anonymous:
                return (
                    <Tooltip title={commonText?.tooltipAnonymousDC || ''}>
                        <FontAwesomeIcon id={iconId} style={iconStyle} icon={faQuestion} />
                    </Tooltip>
                );
            case LinkMode.shareable:
                return (
                    <Tooltip title={commonText?.tooltipSecureURL || ''}>
                        <FontAwesomeIcon id={iconId} style={iconStyle} icon={faShareAlt} />
                    </Tooltip>
                );
            case LinkMode.direct:
                return (
                    <Tooltip title={commonText?.tooltipDirectConnection || ''}>
                        <FontAwesomeIcon id={iconId} style={iconStyle} icon={faFileExport} />
                    </Tooltip>
                )
        }
        return (<></>);

        // linkType is the only dependency on want.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkType])

    return content;
}


export const SubmittedByIcon = connect<InjectedReduxState, InjectedActionCreators, SubmittedByIconProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            brandConfig: GetBrandConfig(appState),
            commonText: GetPortalText<PortalTextCommon>(appState, 'commonText'),
        };
        return result;
    }
)(SubmittedByIconComponent);
